/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RenderTemplateResult = {
  /**
   * The rendered prompt
   */
  prompt: string;
};

/** @internal */
export const RenderTemplateResult$inboundSchema: z.ZodMiniType<
  RenderTemplateResult,
  unknown
> = z.object({
  prompt: z.string(),
});

export function renderTemplateResultFromJSON(
  jsonString: string,
): SafeParseResult<RenderTemplateResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RenderTemplateResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RenderTemplateResult' from JSON`,
  );
}
